import Faqs from 'components/marketingSite/shared/Faqs';
import HtmlTrans from 'components/shared/HtmlTrans';
import { LinkText } from 'components/shared/LinkText';
import TooltipMF from 'components/shared/TooltipMF';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import {
  StyledCard,
  StyledCardIcon,
  StyledCardLink,
  StyledCards,
  StyledCardSeparator,
  StyledCardTitle,
  StyledContainer
} from './PrivacyPolicyData.styled';

const PrivacyPolicyData: React.FC = () => {
  const { t } = useI18n('privacyPolicy');
  const { locale } = useRouter();

  const dataCard = [
    {
      icon: getPublicPath('/images/icons/cookies.svg'),
      title: t('data.dataCards.cardCookies.title'),
      text: t('data.dataCards.cardCookies.text'),
      link: t('data.dataCards.cardCookies.textLink'),
      linkHref: getAppUrl(APP_URLS.cookies, locale)
    },
    {
      icon: getPublicPath('/images/icons/usage-data.svg'),
      title: t('data.dataCards.cardUsarage.title'),
      text: t('data.dataCards.cardUsarage.text'),
      link: t('data.dataCards.cardUsarage.textLink'),
      linkHref: '#dataTools'
    },
    {
      icon: getPublicPath('/images/icons/consent.svg'),
      title: t('data.dataCards.freely.title'),
      text: t('data.dataCards.freely.text'),
      link: t('data.dataCards.freely.textLink'),
      linkHref: '#',
      tooltip: t('data.dataCards.freely.toolTip')
    }
  ];
  const dataFaqs = [
    {
      question: t('data.faqs.faq1.question'),
      answer: (
        <HtmlTrans
          ns={'privacyPolicy'}
          i18nKey={'data.faqs.faq1.answer'}
          components={{
            privacyGoogle: (
              <a
                href="https://www.google.com/intl/en/policies/privacy/"
                target={'-blank'}
              ></a>
            ),
            privacyAnalytics: (
              <a
                href="https://tools.google.com/dlpage/gaoptout"
                target={'-blank'}
              ></a>
            )
          }}
        />
      ),
      renderComponent: true
    },
    {
      question: t('data.faqs.faq2.question'),
      answer: t('data.faqs.faq2.answer')
    },
    {
      question: t('data.faqs.faq3.question'),
      answer: (
        <HtmlTrans
          ns={'privacyPolicy'}
          i18nKey={'data.faqs.faq3.answer'}
          components={{
            privacyGoogle: (
              <a
                href="https://www.google.com/intl/en/policies/privacy/"
                target="_blank"
                rel="noreferrer"
              ></a>
            ),
            privacyAnalytics: (
              <a
                href="https://tools.google.com/dlpage/gaoptout"
                target="_blank"
                rel="noreferrer"
              ></a>
            ),

            mail: <a href="mailto:team@getmanfred.com"></a>
          }}
        />
      ),
      renderComponent: true
    },

    {
      question: t('data.faqs.faq4.question'),
      answer: (
        <HtmlTrans
          ns={'privacyPolicy'}
          i18nKey={'data.faqs.faq4.answer'}
          components={{
            privacyGoogle: (
              <a
                href="https://www.google.com/intl/en/policies/privacy/"
                target={'-blank'}
              ></a>
            ),
            privacyAnalytics: (
              <a
                href="https://tools.google.com/dlpage/gaoptout"
                target="_blank"
                rel="noreferrer"
              ></a>
            )
          }}
        />
      ),
      renderComponent: true
    },
    {
      question: t('data.faqs.faq5.question'),
      answer: (
        <HtmlTrans
          ns={'privacyPolicy'}
          i18nKey={'data.faqs.faq5.answer'}
          components={{
            manfredDaily: (
              <LinkText href={getAppUrl(APP_URLS.manfredDaily, locale)} />
            ),
            mailchimpPrivacy: <a href="https://telegram.org/privacy"></a>,
            telegramPrivacy: <a href="https://telegram.org/privacy"></a>
          }}
        />
      ),
      renderComponent: true
    },
    {
      question: t('data.faqs.faq6.question'),
      answer: (
        <HtmlTrans
          ns={'privacyPolicy'}
          i18nKey={'data.faqs.faq6.answer'}
          components={{
            privacyDigitalOcean: (
              <a href="https://www.digitalocean.com/legal/privacy-policy"></a>
            )
          }}
        />
      ),
      renderComponent: true
    }
  ];
  return (
    <StyledContainer>
      <Heading2 editorial>{t('data.title')}</Heading2>
      <StyledCards>
        {dataCard.map((c, i) => (
          <StyledCard key={i}>
            <StyledCardIcon src={c.icon} alt="" />
            <StyledCardSeparator />
            <StyledCardTitle>{c.title}</StyledCardTitle>
            <p dangerouslySetInnerHTML={{ __html: c.text }}></p>
            {!c.tooltip && (
              <StyledCardLink href={c.linkHref}>{c.link}</StyledCardLink>
            )}
            {c.tooltip && (
              <TooltipMF content={c.tooltip} direction="down">
                <StyledCardLink href="#" onClick={(e) => e.preventDefault()}>
                  {c.link}
                </StyledCardLink>
              </TooltipMF>
            )}
          </StyledCard>
        ))}
      </StyledCards>
      <div id="dataTools">
        <Faqs faqs={dataFaqs} h3 title={t('data.faqs.title')} />
      </div>
    </StyledContainer>
  );
};

export default PrivacyPolicyData;
